// One slow editorial marquee — outlined type drifting between sections.
export const Marquee = ({ items, tone = "dark" }) => {
  const row = [...items, ...items, ...items, ...items];
  const color = tone === "dark" ? "text-outline-ivory" : "text-outline-carbon";
  return (
    <div className={`relative overflow-hidden py-10 ${tone === "dark" ? "" : "border-y border-[#171717]/10"}`} aria-hidden="true" data-testid="marquee">
      <div className="marquee-track items-baseline gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-baseline gap-10 whitespace-nowrap">
            <span className={`text-4xl font-light uppercase tracking-[0.12em] sm:text-6xl ${color}`}>
              {item}
            </span>
            <span className="text-lg text-[#C6A46A]">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
